import React, { useState, useEffect } from 'react'
import {
  Box,
  Card,
  Tabs,
  Tab,
  Skeleton,
  Button,
  Typography,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider
} from '@mui/material'

import { connect } from 'react-redux'
import { hashHistory } from 'react-router'
// Import tab components
import { useParams } from 'react-router-dom'
import {
  Shield,
  Inbox,
  CardGiftcard,
  People,
  Autorenew,
  Assessment,
  ArrowBack,
  SmartToy,
  WarningAmber,
  Visibility,
  Close,
  ExpandMore,
  Tune,
  FactCheck,
  TableChart
} from '@mui/icons-material'
import ProductInfoTab from '../../../components/GenericProductConfig/components/Products/Product.js'
import PackagesTab from '../../../components/GenericProductConfig/components/Packages/PackagesTab.js'
import AddonsTab from '../../../components/GenericProductConfig/components/AddOns/AddonsTab.js'
import CashbackTab from '../../../components/GenericProductConfig/components/Cashback/CashbackTab.js'
import AgeRulesTab from '../../../components/GenericProductConfig/components/AgeRules/AgeRulesTab.js'
import AutoRenewalTab from '../../../components/GenericProductConfig/components/AutoRenewal/AutoRenewalTab.js'
import RatingNodesTab from '../../../components/GenericProductConfig/components/RatingNodes/RatingNodesTab.js'
import FactsGovernanceTab from '../../../components/GenericProductConfig/components/Governance/FactsGovernanceTab.js'
import AllocationSettingsTab from '../../../components/GenericProductConfig/components/Governance/AllocationSettingsTab.js'
import RatingTablesScreen from '../components/RatingTables/RatingTablesScreen'
import Audit from '../../Audits'
import QuotationDialog from '../components/QuotationDialog/QuotationDialog'
import {
  getPartnerGuid,
  canAccessQuotations
} from '../../../lib/access.es6.js'

import * as actions from '../actions.es6.js'

function InsuranceProduct(props) {
  console.log('GenericProduct Data :', props.genericProductsData)
  const [activeTab, setActiveTab] = useState(0)

  const params = useParams()

  console.log('Product GUID from params:', params)
  const partner = getPartnerGuid()

  useEffect(() => {
    // Fetch product details when component mounts / product changes.
    // Depend on the stable guid (not `props`, which is a fresh object every
    // render and would re-fire this fetch forever).
    props.dispatch(actions.getProductRequest(props.params.productGuid))
    props.dispatch(
      actions.getProductRatingNodesRequest(props.params.productGuid)
    )
    // Partner rating tables — needed to resolve a node's linked table guids to
    // names (Rating Nodes cards + edit dialog).
    props.dispatch(actions.getRatingTablesRequest())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.params.productGuid])

  // Refresh product data after addon operations
  useEffect(() => {
    if (props.genericProductsData.productAddonSuccess) {
      // Small delay to ensure backend has processed the change
      setTimeout(() => {
        console.log('Refreshing product data after addon operation success')
        props.dispatch(actions.getProductRequest(props.params.productGuid))
      }, 100)
    }
  }, [
    props.params.productGuid,
    props.genericProductsData.productAddonSuccess,
    props
  ])

  // Refresh product data after package operations
  useEffect(() => {
    if (props.genericProductsData.productPackageSuccess) {
      setTimeout(() => {
        console.log('Refreshing product data after package operation success')
        props.dispatch(actions.getProductRequest(props.params.productGuid))
      }, 100)
    }
  }, [
    props.params.productGuid,
    props.genericProductsData.productPackageSuccess,
    props
  ])

  // Refresh product data after benefit operations
  useEffect(() => {
    if (props.genericProductsData.productPackageBenefitSuccess) {
      setTimeout(() => {
        console.log('Refreshing product data after benefit operation success')
        props.dispatch(actions.getProductRequest(props.params.productGuid))
      }, 100)
    }
  }, [
    props.params.productGuid,
    props.genericProductsData.productPackageBenefitSuccess,
    props
  ])

  // Refresh product data after cashback operations
  useEffect(() => {
    if (props.genericProductsData.cashBackConfigSuccess) {
      setTimeout(() => {
        console.log('Refreshing product data after cashback operation success')
        props.dispatch(actions.getProductRequest(props.params.productGuid))
      }, 100)
    }
  }, [
    props.params.productGuid,
    props.genericProductsData.cashBackConfigSuccess,
    props
  ])

  // Refresh product data after age rule operations
  useEffect(() => {
    if (props.genericProductsData.ageValidationRuleSuccess) {
      setTimeout(() => {
        console.log('Refreshing product data after age rule operation success')
        props.dispatch(actions.getProductRequest(props.params.productGuid))
      }, 100)
    }
  }, [
    props.params.productGuid,
    props.genericProductsData.ageValidationRuleSuccess,
    props
  ])

  // Refresh product data after auto-renewal operations
  useEffect(() => {
    if (props.genericProductsData.productAutoRenewalConfigSuccess) {
      setTimeout(() => {
        console.log(
          'Refreshing product data after auto-renewal operation success'
        )
        props.dispatch(actions.getProductRequest(props.params.productGuid))
      }, 100)
    }
  }, [
    props.params.productGuid,
    props.genericProductsData.productAutoRenewalConfigSuccess,
    props
  ])

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue)
  }

  const handleCreateProductInfo = data => {
    props.dispatch(actions.createProductRequest({ ...data, partner }))
  }

  const handleEditProductInfo = data => {
    props.dispatch(
      actions.editProductRequest({
        ...data,
        partner,
        product_guid: props.params.productGuid
      })
    )
  }

  const handleEditProductPackages = data => {
    props.dispatch(
      actions.updateProductPackageRequest({
        ...data,
        partner,
        package_guid: data.package_guid,
        product_guid: props.params.productGuid
      })
    )
  }

  const handleDeleteProductPackages = package_guid => {
    props.dispatch(
      actions.deleteProductPackageRequest({
        package_guid,
        partner,
        product_guid: props.params.productGuid
      })
    )
  }

  const handleEditPackageBenefits = data => {
    props.dispatch(
      actions.updateProductPackageBenefitRequest({
        ...data,
        partner,
        benefit_guid: data.benefit_guid,
        product_guid: props.params.productGuid
      })
    )
  }

  const handleDeletePackageBenefits = benefit_guid => {
    props.dispatch(
      actions.deleteProductPackageBenefitRequest({
        benefit_guid,
        partner,
        product_guid: props.params.productGuid
      })
    )
  }

  const handleSubmitPackage = data => {
    props.dispatch(
      actions.createProductPackageRequest({
        ...data,
        partner,
        product_guid: props.params.productGuid
      })
    )
    console.log('Submitting Package Info from index:', data)
  }

  const handleSubmitBenefits = data => {
    console.log('Submitting Add-ons Info:', data)
    props.dispatch(
      actions.createProductPackageBenefitRequest({
        ...data,
        partner,
        product_guid: props.params.productGuid
      })
    )
  }

  // AddBenefitWizard's "Per rule" path — see
  // docs/2026-09-04-benefit-pricing-wizard-design.md §5.1.
  const handleCreateBenefitWithRules = ({ targets, benefitPayload, package_guid }) => {
    props.dispatch(
      actions.createBenefitRatingChainRequest({
        product_guid: props.params.productGuid,
        package_guid,
        targets,
        benefitPayload
      })
    )
  }

  const resetBenefitRatingChainState = () => {
    props.dispatch(actions.resetBenefitRatingChainState())
  }

  // AddBenefitWizard's edit-mode path — see
  // docs/2026-09-04-benefit-pricing-wizard-design.md §9.3.
  const handleUpdateBenefitWithRules = ({ createTargets, updateTargets, benefitPayload, package_guid, benefit_guid }) => {
    props.dispatch(
      actions.updateBenefitRatingChainRequest({
        product_guid: props.params.productGuid,
        package_guid,
        benefit_guid,
        createTargets,
        updateTargets,
        benefitPayload
      })
    )
  }

  const resetUpdateBenefitRatingChainState = () => {
    props.dispatch(actions.resetUpdateBenefitRatingChainState())
  }

  const handleSubmitAddons = data => {
    console.log('Submitting Add-ons Info:', data)
    // Handle form submission logic here
    props.dispatch(
      actions.createProductAddonRequest({
        ...data,
        partner,
        product_guid: props.params.productGuid
      })
    )
  }

  const handleEditAddons = data => {
    console.log('Editing Add-ons Info:', data)
    // Handle form submission logic here
    props.dispatch(
      actions.updateProductAddonRequest({
        ...data,
        partner,
        add_on_guid: data.add_on_guid,
        product_guid: props.params.productGuid
      })
    )
  }

  const handleDeleteAddons = add_on_guid => {
    console.log('Deleting Add-ons Info:', add_on_guid)
    // Handle form submission logic here
    props.dispatch(
      actions.deleteProductAddonRequest({
        add_on_guid,
        partner,
        product_guid: props.params.productGuid
      })
    )
  }

  const handleSubmitCashback = data => {
    console.log('Submitting Cashback Info:', data)
    // Handle form submission logic here
    props.dispatch(
      actions.createCashBackConfigRequest({
        ...data,
        partner,
        product_guid: props.params.productGuid
      })
    )
  }

  const handleEditCashback = data => {
    console.log('Editing Cashback Info:', data)
    // Handle form submission logic here
    props.dispatch(
      actions.updateCashBackConfigRequest({
        ...data,
        partner,
        cashback_guid: data.cashback_guid,
        product_guid: props.params.productGuid
      })
    )
  }

  const handleDeleteCashback = cashback_guid => {
    console.log('Deleting Cashback Info:', cashback_guid)
    // Handle form submission logic here
    props.dispatch(
      actions.deleteCashBackConfigRequest({
        cashback_guid,
        partner,
        product_guid: props.params.productGuid
      })
    )
  }

  const handleSubmitAgeRules = data => {
    console.log(
      'Submitting Age Rules Info:',
      data,
      'from product config index, partner:',
      partner
    )
    // Handle form submission logic here
    console.log('Dispatching createAgeValidationRuleRequest with payload:', {
      ...data,
      partner,
      product_guid: props.params.productGuid
    })
    props.dispatch(
      actions.createAgeValidationRuleRequest({
        ...data,
        partner,
        product_guid: props.params.productGuid
      })
    )
  }

  const handleEditAgeValidationRules = data => {
    console.log('Editing Age Rules Info:', data)
    // Handle form submission logic here
    props.dispatch(
      actions.updateAgeValidationRuleRequest({
        ...data,
        partner,
        product_guid: props.params.productGuid
      })
    )
  }

  const handleDeleteAgeValidationRules = rule_guid => {
    console.log('Deleting Age Rules Info:', rule_guid)
    // Handle form submission logic here
    props.dispatch(
      actions.deleteAgeValidationRuleRequest({
        rule_guid,
        product_guid: props.params.productGuid
      })
    )
  }

  // Reset functions for clearing success/error states
  const resetProductSuccess = () => {
    props.dispatch(actions.resetCreateProductSuccess())
  }

  const resetProductError = () => {
    props.dispatch(actions.resetCreateProductError())
  }

  const resetEditProductSuccess = () => {
    props.dispatch(actions.resetEditProductSuccess())
  }

  const resetEditProductError = () => {
    props.dispatch(actions.resetEditProductError())
  }

  const resetPackageSuccess = () => {
    props.dispatch(actions.resetCreateProductPackageSuccess())
  }

  const resetPackageError = () => {
    props.dispatch(actions.resetCreateProductPackageError())
  }

  const resetBenefitsSuccess = () => {
    props.dispatch(actions.resetCreateProductPackageBenefitSuccess())
  }

  const resetBenefitsError = () => {
    props.dispatch(actions.resetCreateProductPackageBenefitError())
  }

  const resetAddonSuccess = () => {
    props.dispatch(actions.resetCreateProductAddonSuccess())
  }

  const resetAddonError = () => {
    props.dispatch(actions.resetCreateProductAddonError())
  }

  const resetCashbackSuccess = () => {
    props.dispatch(actions.resetCreateCashBackConfigSuccess())
  }

  const resetCashbackError = () => {
    props.dispatch(actions.resetCreateCashBackConfigError())
  }

  const resetAgeRuleSuccess = () => {
    props.dispatch(actions.resetCreateAgeValidationRuleSuccess())
  }

  const resetAgeRuleError = () => {
    props.dispatch(actions.resetCreateAgeValidationRuleError())
  }

  const createProductAutoRenewal = data => {
    props.dispatch(
      actions.createProductAutoRenewalConfigRequest({
        ...data,
        partner,
        product_guid: props.params.productGuid
      })
    )
  }

  const editProductAutoRenewal = data => {
    props.dispatch(
      actions.updateProductAutoRenewalConfigRequest({
        ...data,
        partner,
        renewal_guid: data.renewal_guid,
        product_guid: props.params.productGuid
      })
    )
  }

  const deleteProductAutoRenewal = renewal_guid => {
    props.dispatch(actions.deleteProductAutoRenewalConfigRequest(renewal_guid))
  }

  const resetAutoRenewalSuccess = () => {
    props.dispatch(actions.resetProductAutoRenewalConfigSuccess())
  }

  const resetAutoRenewalError = () => {
    props.dispatch(actions.resetProductAutoRenewalConfigError())
  }

  const handleCreateRatingNode = data => {
    props.dispatch(
      actions.createProductRatingNodeRequest({
        ...data,
        partner,
        product_guid: props.params.productGuid
      })
    )
  }

  const handleUpdateRatingNode = (node_guid, node) => {
    props.dispatch(
      actions.updateProductRatingNodeRequest({ node_guid, node })
    )
  }

  const handleDeleteRatingNode = node_guid => {
    props.dispatch(
      actions.deleteProductRatingNodeRequest({
        node_guid,
        partner,
        product_guid: props.params.productGuid
      })
    )
  }

  const resetRatingNodeSuccess = () => {
    props.dispatch(actions.resetRatingNodeSuccess())
  }

  const resetRatingNodeError = () => {
    props.dispatch(actions.resetRatingNodeError())
  }

  const [quotationDialogOpen, setQuotationDialogOpen] = useState(false)
  const [previewOpen, setPreviewOpen] = useState(false)

  const handleOpenQuotationDialog = () => {
    setQuotationDialogOpen(true)
  }

  const handleCloseQuotationDialog = () => {
    setQuotationDialogOpen(false)
    props.dispatch(actions.resetQuotationResults())
  }

  const handleEvaluateQuote = payload => {
    props.dispatch(actions.evaluateProductQuoteRequest(payload))
  }

  // Collapsible section wrapper used to fold the smaller sub-entity forms
  // (cashback, age rules, auto-renewal) under the Overview tab without losing
  // any of their existing forms/handlers.
  const foldSection = (icon, title, subtitle, node) => (
    <Accordion
      disableGutters
      elevation={0}
      sx={{
        border: '1px solid #E5E7EB',
        borderRadius: 2,
        mb: 2,
        '&:before': { display: 'none' }
      }}
    >
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          {icon}
          <Box>
            <Typography sx={{ fontWeight: 600, color: '#1f2937' }}>{title}</Typography>
            {subtitle && (
              <Typography variant="caption" sx={{ color: '#6B7280' }}>
                {subtitle}
              </Typography>
            )}
          </Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails>{node}</AccordionDetails>
    </Accordion>
  )

  const productInfoTab = (
    <ProductInfoTab
      onProductInfoSubmit={handleCreateProductInfo}
      onProductInfoEdit={handleEditProductInfo}
      productSuccess={props.genericProductsData.productSuccess}
      productError={props.genericProductsData.productError}
      productLoader={props.genericProductsData.productLoader}
      resetProductSuccess={resetProductSuccess}
      resetProductError={resetProductError}
      editProductSuccess={props.genericProductsData.productSuccess}
      editProductError={props.genericProductsData.productError}
      editProductLoader={props.genericProductsData.productLoader}
      resetEditProductSuccess={resetEditProductSuccess}
      resetEditProductError={resetEditProductError}
      currentProduct={props.genericProductsData.currentProduct}
    />
  )

  const cashbackTab = (
    <CashbackTab
      handleCashBack={handleSubmitCashback}
      handleEditCashBack={handleEditCashback}
      handleDeleteCashBack={handleDeleteCashback}
      cashback={
        props.genericProductsData.currentProduct &&
        props.genericProductsData.currentProduct.cashback
      }
      currency={
        props.genericProductsData.currentProduct &&
        props.genericProductsData.currentProduct.currency
      }
      isLoading={props.genericProductsData.cashBackConfigLoader}
      isError={props.genericProductsData.cashBackConfigError}
      isSuccess={props.genericProductsData.cashBackConfigSuccess}
      resetCashbackSuccess={resetCashbackSuccess}
      resetCashbackError={resetCashbackError}
    />
  )

  const ageRulesTab = (
    <AgeRulesTab
      handleAddAgeRules={handleSubmitAgeRules}
      handleEditAgeRules={handleEditAgeValidationRules}
      handleDeleteAgeRules={handleDeleteAgeValidationRules}
      ageRules={
        props.genericProductsData.currentProduct &&
        props.genericProductsData.currentProduct.age_validation_rules
      }
      isLoading={props.genericProductsData.ageValidationRuleLoader}
      isError={props.genericProductsData.ageValidationRuleError}
      isSuccess={props.genericProductsData.ageValidationRuleSuccess}
      resetAgeRuleSuccess={resetAgeRuleSuccess}
      resetAgeRuleError={resetAgeRuleError}
    />
  )

  const autoRenewalTab = (
    <AutoRenewalTab
      handleAddAutoRenewal={createProductAutoRenewal}
      handleEditAutoRenewal={editProductAutoRenewal}
      handleDeleteAutoRenewal={deleteProductAutoRenewal}
      autoRenewal={
        props.genericProductsData.currentProduct &&
        props.genericProductsData.currentProduct.renewal
      }
      isLoading={props.genericProductsData.productAutoRenewalConfigLoader}
      isError={props.genericProductsData.productAutoRenewalConfigError}
      isSuccess={props.genericProductsData.productAutoRenewalConfigSuccess}
      resetAutoRenewalSuccess={resetAutoRenewalSuccess}
      resetAutoRenewalError={resetAutoRenewalError}
    />
  )

  const packagesTabFor = (section) => (
    <PackagesTab
      section={section}
      handleAddPackage={handleSubmitPackage}
      handleAddBenefits={handleSubmitBenefits}
      handleAddBenefitWithRules={handleCreateBenefitWithRules}
      resetBenefitRatingChainState={resetBenefitRatingChainState}
      benefitRatingChainLoader={props.genericProductsData.benefitRatingChainLoader}
      benefitRatingChainError={props.genericProductsData.benefitRatingChainError}
      benefitRatingChainProgress={props.genericProductsData.benefitRatingChainProgress}
      handleUpdateBenefitWithRules={handleUpdateBenefitWithRules}
      resetUpdateBenefitRatingChainState={resetUpdateBenefitRatingChainState}
      updateBenefitRatingChainLoader={props.genericProductsData.updateBenefitRatingChainLoader}
      updateBenefitRatingChainError={props.genericProductsData.updateBenefitRatingChainError}
      updateBenefitRatingChainPending={props.genericProductsData.updateBenefitRatingChainPending}
      updateBenefitRatingChainProgress={props.genericProductsData.updateBenefitRatingChainProgress}
      handleEditPackage={handleEditProductPackages}
      handleDeleteProductPackages={handleDeleteProductPackages}
      handleEditPackageBenefits={handleEditPackageBenefits}
      handleDeleteBenefits={handleDeletePackageBenefits}
      isLoading={props.genericProductsData.productPackageLoader}
      isSuccess={props.genericProductsData.productPackageSuccess}
      isError={props.genericProductsData.productPackageError}
      createdPackage={props.genericProductsData.createdProductPackage}
      resetPackageSuccess={resetPackageSuccess}
      resetPackageError={resetPackageError}
      benefitsLoader={props.genericProductsData.productPackageBenefitLoader}
      benefitsError={props.genericProductsData.productPackageBenefitError}
      benefitsSuccess={props.genericProductsData.productPackageBenefitSuccess}
      resetBenefitsSuccess={resetBenefitsSuccess}
      resetBenefitsError={resetBenefitsError}
      packages={
        props.genericProductsData.currentProduct &&
        props.genericProductsData.currentProduct.packages
      }
      ratingNodes={props.genericProductsData.ratingNodes || []}
      currency={
        props.genericProductsData.currentProduct &&
        props.genericProductsData.currentProduct.currency
      }
    />
  )

  const addonsTab = (
    <AddonsTab
      handleAddAddons={handleSubmitAddons}
      handleEditAddons={handleEditAddons}
      handleDeleteAddons={handleDeleteAddons}
      isLoading={props.genericProductsData.productAddonLoader}
      isError={props.genericProductsData.productAddonError}
      isSuccess={props.genericProductsData.productAddonSuccess}
      resetAddonSuccess={resetAddonSuccess}
      resetAddonError={resetAddonError}
      addons={
        props.genericProductsData.currentProduct &&
        props.genericProductsData.currentProduct.add_ons
      }
      ratingNodes={props.genericProductsData.ratingNodes || []}
      currency={
        props.genericProductsData.currentProduct &&
        props.genericProductsData.currentProduct.currency
      }
    />
  )

  const ratingNodesTab = (
    <RatingNodesTab
      ratingNodes={props.genericProductsData.ratingNodes || []}
      ratingTables={props.genericProductsData.ratingTables || []}
      isLoading={props.genericProductsData.ratingNodeLoader}
      isError={props.genericProductsData.ratingNodeError}
      isSuccess={props.genericProductsData.ratingNodeSuccess}
      onCreateRatingNode={handleCreateRatingNode}
      onUpdateRatingNode={handleUpdateRatingNode}
      onDeleteRatingNode={handleDeleteRatingNode}
      resetSuccess={resetRatingNodeSuccess}
      resetError={resetRatingNodeError}
    />
  )

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        // Overview — product basics, then the smaller product-level configs
        // folded as collapsible sections (nothing dropped).
        return (
          <Box>
            {productInfoTab}
            <Box sx={{ mt: 4 }}>
              <Typography
                sx={{ fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', color: '#6B7280', mb: 1.5 }}
              >
                Product-level configuration
              </Typography>
              {foldSection(
                <CardGiftcard sx={{ color: '#173E4B' }} />,
                'Cashback',
                'Loyalty / cashback configuration',
                cashbackTab
              )}
              {foldSection(
                <People sx={{ color: '#173E4B' }} />,
                'Age Rules',
                'Age validation rules',
                ageRulesTab
              )}
              {foldSection(
                <Autorenew sx={{ color: '#173E4B' }} />,
                'Auto-Renewal',
                'Renewal configuration',
                autoRenewalTab
              )}
            </Box>
          </Box>
        )
      case 1:
        // Packages — package-level config only (each package's benefits move to
        // the Benefits & Rating Nodes tab, matching the prototype).
        return packagesTabFor('packages')
      case 2:
        // Benefits & Rating Nodes — every package's benefits (grouped by package),
        // then product-level add-ons, then the rating-node manager.
        return (
          <Box>
            {packagesTabFor('benefits')}
            <Divider sx={{ my: 4 }} />
            {addonsTab}
            <Divider sx={{ my: 4 }} />
            {ratingNodesTab}
          </Box>
        )
      case 3:
        // Rating Tables — the whole partner catalogue (RatingTablesScreen has
        // full create/edit/activate/delete CRUD). Moved here from the
        // products-list module tab.
        return <RatingTablesScreen productGuid={props.params.productGuid} />
      case 4:
        return (
          <FactsGovernanceTab
            product={props.genericProductsData.currentProduct}
            auditSlot={<Audit entity_guid={props.params.productGuid} size={10} />}
          />
        )
      case 5:
        // Allocation / governance edits reuse the standard product-edit dispatch;
        // benefit_allocation / benefit_groups are valid ProductDto fields and the
        // backend PUT is a shallow patch (other product fields are preserved).
        return (
          <AllocationSettingsTab
            product={props.genericProductsData.currentProduct}
            isLoading={props.genericProductsData.productLoader}
            onSave={handleEditProductInfo}
            isSuccess={props.genericProductsData.productSuccess}
            isError={props.genericProductsData.productError}
            resetSuccess={resetEditProductSuccess}
            resetError={resetEditProductError}
          />
        )
      default:
        return null
    }
  }

  const currentProduct = props.genericProductsData.currentProduct || {}
  const productActive = currentProduct.active !== false

  const metaChip = (icon, label) => (
    <Chip
      size="small"
      variant="outlined"
      icon={icon}
      label={label}
      sx={{
        height: 24,
        fontSize: 11.5,
        color: '#374151',
        borderColor: '#E5E7EB',
        '& .MuiChip-icon': { fontSize: 15, color: '#6B7280', ml: 0.5 }
      }}
    />
  )

  return (
    <Box sx={{ maxWidth: '1400px', mx: 'auto', p: 3 }}>
      {/* Editor header — product identity, status, meta & actions */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          flexWrap: 'wrap',
          gap: 2,
          mb: 3
        }}
      >
        <Box>
          <Box
            onClick={() => hashHistory.push('admin/generic-products')}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.5,
              fontSize: 12,
              color: '#6B7280',
              cursor: 'pointer',
              mb: 0.5,
              '&:hover': { color: '#173E4B' }
            }}
          >
            <ArrowBack sx={{ fontSize: 14 }} /> Products
          </Box>
          <Typography variant="h5" sx={{ fontWeight: 700, color: '#1f2937' }}>
            {currentProduct.name || 'Product'}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1, flexWrap: 'wrap' }}>
            <Chip
              size="small"
              label={productActive ? 'Active' : 'Inactive'}
              sx={{
                height: 24,
                fontSize: 11,
                fontWeight: 700,
                bgcolor: productActive ? '#F0FDF4' : '#FEF2F2',
                color: productActive ? '#15803D' : '#B91C1C',
                border: productActive ? '1px solid #BBF7D0' : '1px solid #FECACA'
              }}
            />
            {currentProduct.code && metaChip(<Inbox />, currentProduct.code)}
            {partner && metaChip(<People />, partner)}
            {currentProduct.version != null && metaChip(null, 'v' + currentProduct.version)}
            {currentProduct.source_template_guid &&
              metaChip(<SmartToy />, 'AI Imported')}
            {currentProduct.requires_manual_review && (
              <Chip
                size="small"
                icon={<WarningAmber />}
                label="Manual review"
                sx={{
                  height: 24,
                  fontSize: 11,
                  fontWeight: 600,
                  bgcolor: '#FFF7ED',
                  color: '#9A3412',
                  border: '1px solid #FED7AA',
                  '& .MuiChip-icon': { fontSize: 15, color: '#C2410C' }
                }}
              />
            )}
          </Box>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
          <Button
            variant="outlined"
            startIcon={<Visibility />}
            onClick={() => setPreviewOpen(true)}
            sx={{
              textTransform: 'none',
              color: '#173E4B',
              borderColor: '#173E4B',
              '&:hover': { borderColor: '#173E4B', bgcolor: 'rgba(23,62,75,0.04)' }
            }}
          >
            Preview
          </Button>
          {canAccessQuotations() && (
            <Button
              variant="contained"
              startIcon={<Assessment />}
              onClick={handleOpenQuotationDialog}
              sx={{
                textTransform: 'none',
                bgcolor: '#173E4B',
                '&:hover': { bgcolor: '#0f2d38' }
              }}
            >
              Create Quotation
            </Button>
          )}
        </Box>
      </Box>

      {/* Tabs Navigation */}
      <Card sx={{ mb: 3 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            '& .MuiTabs-indicator': {
              backgroundColor: '#173E4B'
            },
            '& .MuiTab-root': {
              color: '#000000',
              '&.Mui-selected': {
                color: '#173E4B'
              },
              '&:hover': {
                color: '#173E4B'
              }
            }
          }}
        >
          <Tab
            icon={<Shield sx={{ fontSize: 20 }} />}
            iconPosition="start"
            label="Overview"
            sx={{ textTransform: 'none', minHeight: 48 }}
          />
          <Tab
            icon={<Inbox sx={{ fontSize: 20 }} />}
            iconPosition="start"
            label="Packages"
            sx={{ textTransform: 'none', minHeight: 48 }}
          />
          <Tab
            icon={<Assessment sx={{ fontSize: 20 }} />}
            iconPosition="start"
            label="Benefits & Rating"
            sx={{ textTransform: 'none', minHeight: 48 }}
          />
          <Tab
            icon={<TableChart sx={{ fontSize: 20 }} />}
            iconPosition="start"
            label="Rating Tables"
            sx={{ textTransform: 'none', minHeight: 48 }}
          />
          <Tab
            icon={<FactCheck sx={{ fontSize: 20 }} />}
            iconPosition="start"
            label="Facts & Governance"
            sx={{ textTransform: 'none', minHeight: 48 }}
          />
          <Tab
            icon={<Tune sx={{ fontSize: 20 }} />}
            iconPosition="start"
            label="Allocation & Settings"
            sx={{ textTransform: 'none', minHeight: 48 }}
          />
        </Tabs>
      </Card>

      {/* Main Form Content */}
      <Card sx={{ p: 4 }}>
        {props.genericProductsData.loader ? (
          <Box>
            <Skeleton variant="rectangular" height={40} sx={{ mb: 2 }} />
            <Skeleton variant="rectangular" height={200} />
          </Box>
        ) : (
          renderTabContent()
        )}
      </Card>

      {canAccessQuotations() && (
        <QuotationDialog
          open={quotationDialogOpen}
          onClose={handleCloseQuotationDialog}
          currentProduct={props.genericProductsData.currentProduct}
          quotationResults={props.genericProductsData.quotationResults}
          quotationLoader={props.genericProductsData.quotationLoader}
          quotationError={props.genericProductsData.quotationError}
          onEvaluate={handleEvaluateQuote}
        />
      )}

      {/* Product Preview — quick read-only summary */}
      <Dialog
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2 } }}
      >
        <DialogTitle
          sx={{
            fontWeight: 700,
            fontSize: 16,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Visibility sx={{ fontSize: 20, color: '#173E4B' }} /> Product Preview
          </Box>
          <IconButton size="small" onClick={() => setPreviewOpen(false)}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            {[
              ['Name', currentProduct.name || '—'],
              ['Code', currentProduct.code || '—'],
              ['Type', currentProduct.type || '—'],
              ['Cover', currentProduct.cover_type || '—'],
              ['Currency', currentProduct.currency || '—'],
              ['Status', productActive ? 'Active' : 'Inactive'],
              ['Packages', (currentProduct.packages || []).length],
              ['Add-ons', (currentProduct.add_ons || []).length],
              ['Rating Nodes', (props.genericProductsData.ratingNodes || []).length],
              [
                'Allocation',
                currentProduct.benefit_allocation === 'MixAndMatchByGroup'
                  ? 'Mix and Match by Group'
                  : currentProduct.benefit_allocation === 'SinglePackage'
                  ? 'Single Package'
                  : '—'
              ]
            ].map(([label, value]) => (
              <Grid item xs={6} key={label}>
                <Typography sx={{ fontSize: 11, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                  {label}
                </Typography>
                <Typography sx={{ fontSize: 14, fontWeight: 600, color: '#1f2937' }}>
                  {value}
                </Typography>
              </Grid>
            ))}
          </Grid>
          {currentProduct.requires_manual_review && (
            <Box sx={{ mt: 2, p: 1.5, bgcolor: '#FFF7ED', border: '1px solid #FED7AA', borderRadius: 1.5, display: 'flex', gap: 1, alignItems: 'center' }}>
              <WarningAmber sx={{ fontSize: 18, color: '#C2410C' }} />
              <Typography sx={{ fontSize: 12.5, color: '#9A3412' }}>
                This product is flagged for manual review.
              </Typography>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  )
}

export default connect(state => ({
  productsData: state.newProducts,
  genericProductsData: state.genericProducts,
  globalData: state.global
}))(InsuranceProduct)
